import { Component, Mixins } from 'vue-property-decorator';
import {
    MagicConfigMixin,
    FeatureValueV2,
    ipCountryQuery,
    languageQuery,
    FeatureEnabledV2,
} from '@gig/magic-common';
import { Feature } from '../../util';
import { LanguageSelect } from '../language-select';
import { store } from '../../store';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';
import { RouteName } from '../../routes/routes.constants';
import {
    SINGLE_LANGUAGE_QUERY,
    USER_LOGGED_IN_UPDATED,
} from '@gig/magic-messages';
import { ISubscription } from '@gig/magic-message-bus/dist/base-bus';

enum Languages {
    CA = 'ca',
}
@Component({
    name: 'app-footer',
    components: {
        LanguageSelect,
    },
    store,
})
export default class AppFooter extends Mixins(MagicConfigMixin) {
    RouteName = RouteName;
    Languages = Languages;

    @FeatureValueV2({
        slug: Feature.SOCIAL_MEDIA_ICONS_FOOTER,
        default: undefined,
    })
    socialMediaIconsFooter: string | undefined = '';

    @FeatureEnabledV2({
        slug: Feature.IGOCSE_BETGUARD_BRANDING,
    })
    isBetGuardBrandingEnabled = false;

    isLoggedIn = false;

    currentIpCountry: Country | null = null;

    isSingleLanguage = false;

    language: string = '';
    isLangReady: boolean = false;

    private loggedInSubscription: ISubscription | undefined;

    async created() {
        this.loggedInSubscription = window.eventBus.subscribe<boolean>(
            USER_LOGGED_IN_UPDATED,
            (e) => {
                this.isLoggedIn = e.payload ?? false;
            },
            { replay: true },
        );
        this.currentIpCountry = await ipCountryQuery();
        this.language = await languageQuery();
        this.isLangReady = true;
        this.isSingleLanguage = await window.queryBus.query(
            SINGLE_LANGUAGE_QUERY,
        );
    }

    destroyed() {
        this.loggedInSubscription?.unsubscribe();
    }

    get isCanada() {
        return this.currentIpCountry === Country.CANADA;
    }

    get isFinland() {
        return this.currentIpCountry === Country.FINLAND;
    }

    get isGermany() {
        return this.currentIpCountry === Country.GERMANY;
    }

    get isNorway() {
        return this.currentIpCountry === Country.NORWAY;
    }

    get isSweden() {
        return this.currentIpCountry === Country.SWEDEN;
    }

    get socialMediaIcons() {
        return this.socialMediaIconsFooter?.replace(/\s/g, '').split(',');
    }

    get isSocialMediaIconsEnabled() {
        return this.socialMediaIconsFooter === '' ||
            this.socialMediaIconsFooter === undefined
            ? false
            : true;
    }

    getLanguage(newValue: string){ 
        this.language = newValue;
    }
}
